import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpService } from './api/http.service';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarUpdatesService {
  private progressBar: Subject<void> = new Subject<void>();
  private interval:any;
  private stop:boolean = false;
  private counter:number = 0;
  constructor(
    private _api: HttpService,) {
      
      if(this.getProgressInfo()?.id){
        this.setIntervalTimeFun();
      }
     }

  invokeUpdatedProgressBar(progressObj:any) {
    this.progressBar.next(progressObj);
  }

  getUpdatedProgressBarObservable() {
    return this.progressBar.asObservable();
  }

  setIntervalTimeFun(){
    this.counter = 0;
    this.stop = false;
    this.interval = setInterval(()=>{
      this.getProgressBarAfterFiveSeconds();
    },5000)
  }

  getProgressBarAfterFiveSeconds(){
    let id = this.getProgressInfo()?.id;
    this._api.getReq(`/batch/${id}`).subscribe(res=>{
      this.counter++;
      this.setProgressBarInfo(res?.progress,res?.is_finished,res?.has_failures,res);
    },err=>{})
  }

  setProgressBarInfo(value:any,is_finished:boolean,has_failures:boolean,data?:any){
    if(this.stop){return}
    let obj:any = this.getProgressInfo();
    obj['value'] = value;
    obj['is_finished'] = is_finished;
    obj['has_failures'] = has_failures;
    obj['error_file_url'] = data?.error_file_url || data?.errorFileUrl || data?.failure_file_url || data?.failureFileUrl || data?.file_url || data?.fileUrl || data?.download_url || data?.downloadUrl || obj?.error_file_url || null;
    obj['message'] = data?.message || obj?.message || null;
    this.invokeUpdatedProgressBar(obj);
    if(is_finished || has_failures || this.counter == 30){
      this.removeSetIntervalTime();
      return
    }
    localStorage.setItem('progressBarInfo',JSON.stringify(obj));
  }

  getProgressInfo(){
    return JSON.parse(localStorage.getItem('progressBarInfo')!)
  }

  removeSetIntervalTime(){
    clearInterval(this.interval);
    this.counter = 0;
    this.stop = true;
    localStorage.removeItem('progressBarInfo');
  }

}
